// var languageType = require('./languageCommon.js')
var languageType = require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'

if(language=='zh-CN'){
    document.getElementsByTagName('meta')[1].setAttribute('content',tanchenmeta[language])
    document.getElementsByTagName('meta')[2].setAttribute('content',tanchenkey[language])
    document.title = tanchentitle[language];
}else{
    document.getElementsByTagName('meta')[1].setAttribute('content',tanchenmeta['USA'])
    document.getElementsByTagName('meta')[2].setAttribute('content',tanchenkey['USA'])
    document.title = tanchentitle['USA'];
}

$('.commonlanguage').html(commonlanguage[language])
$('title').html(tanchenTitle[language]);
$('.commonHomePage').html(commonHomePage[language]);
$('.commonLvyue').html(commonLvyue[language]);
$('.commonAboutLvyue').html(commonAboutLvyue[language]);
$('.commonlvyueBrand').html(commonlvyueBrand[language]);
$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
$('.commonFloralLux').html(commonFloralLux[language]);
$('.commonClaim').html(commonClaim[language]);
$('.commonWeiLai').html(commonWeiLai[language]);
$('.commonTanChen').html(commonTanChen[language]);
$('.commonBanlan').html(commonBanlan[language]);
$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
$('.commonPanorama').html(commonPanorama[language]);
$('.buftlanguage1').html(buftlanguage1[language]);
$('.decslan1').html(decslan1[language]);
$('.buftlanguage2').html(buftlanguage2[language]);
$('.decslan2').html(decslan2[language]);
$('.buftlanguage3').html(buftlanguage3[language]);
$('.decslan3').html(decslan3[language]);
$('.aruati').html(aruati[language]);


$('.commonZh').html(commonZh[language]);
$('.commonUsa').html(commonUsa[language]);
$('.commonJp').html(commonJp[language]);
$('.commonKo').html(commonKo[language]);
$('.commonTh').html(commonTh[language]);
$('.commonYh').html(commonYh[language]);
$('.commonflowerTravel').html(commonflowerTravel[language]);
$('.commonReservations a').html(commonReservations[language]);
$('.commonClose').html(commonClose[language]);
$('.commonFreebooking').html(commonFreebooking[language]);
$('.commonDownload').html(commonDownload[language]);
$('.commonWechatSubscription').html(commonWechatSubscription[language]);
$('.commonHuazhuSubscription').html(commonHuazhuSubscription[language]);
$('.commonBrandintroductio').html(commonBrandintroductio[language]);
$('.commonWantJoin').html(commonWantJoin[language]);
$('.commonConectUs').html(commonConectUs[language]);
$('.commonCustomerServiceHotline').html(commonCustomerServiceHotline[language]);
$('.commonConectChina').html(commonCustomerServiceHotlineChina[language]);
$('.commonConectPhilippines').html(commonCustomerServiceHotlinePhilippines[language]);
$('.commonConectJapan').html(commonCustomerServiceHotlineJapan[language]);
$('.commonConectKorea').html(commonCustomerServiceHotlineKorea[language]);
$('.commonConectThailand').html(commonCustomerServiceHotlineThailand[language]);
$('.commonConectYh').html(commonCustomerServiceHotlineYh[language]);
$('.commonCompanyInfo').html(commonCompanyInfo[language]);
$('.commonCompanyBeianInfo').html(commonCompanyBeianInfo[language]);
$('.commonCompanyBeianText').html(commonCompanyBeianText[language]);
$('.commonCompanyLicense').html(commonCompanyLicense[language]);
$('.commonCompanyICP').html(commonCompanyICP[language]);
$('.commonBaina').html(commonBaina[language]);


$('.commonLvyue1').html(commonLvyue1[language]);
$('.Leadership').html(Leadership[language]);
$('.TalentRecruitment').html(TalentRecruitment[language]);
$('.WeiLaiBuildingaboutfbType1').html(homePageSwiperFourDesignideaInfo2[language]);
$('.WeiLaiBuildingaboutfbType3').html(homePageSwiperFourTourismVacationSocialBusiness[language]);
$('.floralReservation').html(floralReservation[language]);

$('.beuDesign').html(beuDesign[language]);
$('.beuDesignType1').html(beuDesignType1[language]);
$('.beuDesignType2').html(beuDesignType2[language]);
$('.beuDesignType3').html(beuDesignType3[language]);
$('.beuBrandIntroductionTitle').html(beuBrandIntroductionTitle[language]);
$('.beuBuildingaboutfbType1').html(beuBuildingaboutfbType1[language]);
$('.beuBrandIntroductionInfo').html(beuBrandIntroductionInfo[language]);
$('.beuBuildingaboutfbType3').html(beuBuildingaboutfbType3[language]);



// WEBPACK FOOTER //
// ./src/js/beuLanguage.js